import { Box, Button } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { GoogleAuthProvider, getAuth, signInWithPopup } from 'firebase/auth'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import GoogleIcon from '../assets/icons/google.svg'

export default function SSOButtons({ disabled }: { disabled?: boolean }) {
  const [loading, setLoading] = useState(false)
  const auth = getAuth()
  const theme = useTheme()
  const navigate = useNavigate()

  const provider = new GoogleAuthProvider()

  async function signInWithGoogle() {
    if (loading) return
    setLoading(true)
    try {
      await signInWithPopup(auth, provider)
      if (window.location.href.includes('preview')) {
        navigate('/web-concierge/')
      }
    } catch (error) {
      console.error('Google sign-in error:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      id='google-sign-in'
      disabled={disabled || loading}
      fullWidth
      onClick={signInWithGoogle}
      size='large'
      variant='outlined'
      sx={{
        color: 'common.black',
        border: `1px solid ${theme.palette.grey[400]}`,
        height: '48px',
      }}
    >
      <Box
        component='img'
        src={GoogleIcon}
        alt='google'
        width={16}
        height={16}
        sx={{ mr: 2 }}
      ></Box>
      Continue with Google
    </Button>
  )
}
